import { FlexJustifyCenter } from 'components/primitives/flex';
import styled from 'styled-components';
import BookingBadge from '../BookingBadge/BookingBadge';

interface Props {
  status: string;
  text: string;
}

const BookingStatusMessage = ({ status, text }: Props) => (
  <MessageType>
    <MessageTypeBadgesContainer>
      <MessageTypeBadge>
        <BookingBadge bookingStatus={status} />
      </MessageTypeBadge>
    </MessageTypeBadgesContainer>
    <MessageTypeText>{text}</MessageTypeText>
  </MessageType>
);

export default BookingStatusMessage;

const MessageType = styled.div`
  margin: 30px 0;
  border-top: 1px solid #dbdfe5;
  padding: 30px 0;
  position: relative;
  text-align: center;
`;

const MessageTypeBadgesContainer = styled(FlexJustifyCenter)`
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 10px;
  background: white;
`;

const MessageTypeBadge = styled.div`
  padding: 0 10px;
`;

const MessageTypeText = styled.h2`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
`;
